import { render } from "./BlFormFieldModel.vue?vue&type=template&id=3b3f768a"
import script from "./BlFormFieldModel.vue?vue&type=script&lang=js"
export * from "./BlFormFieldModel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__